import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { cssClass } from '~src/style';

const classPrefix = 'upload-bundle-dialog';

export namespace UploadBundleDialogStyles {
  export const FullWidthStyle = { width: '100%' };

  export const Section = cssClass(classPrefix, 'section', {
    marginBottom: CommonStyles.Sizes.LineHeight*2,
  });

  export const SectionContent = cssClass(classPrefix, 'section-content', {
    marginLeft: '8px',
  });

  export const SectionHeader = cssClass(classPrefix, 'section-header', {
    fontFamily: 'BentonSans-Medium',
    fontSize: 'inherit',
    fontWeight: 'normal',
    marginBlockStart: 0,
    marginBlockEnd: 0,
    marginBottom: CommonStyles.Sizes.LineHeight,
    marginInlineStart: 0,
    marginInlineEnd: 0,
  });

  export const SectionDescription = cssClass(classPrefix, 'section-description', {
    marginBlockStart: 0,
    marginBlockEnd: 0,
    marginBottom: CommonStyles.Sizes.LineHeight,
    marginInlineStart: 0,
    marginInlineEnd: 0,
  });

  export const PermissionsTooltip = {
     height: 15,
     marginLeft: 3,
     verticalAlign: 'text-top',
     outlineStyle: 'none',
  };

  export const TextField = cssClass(classPrefix, 'text-field', {
    ...FullWidthStyle,
    marginBottom: CommonStyles.Sizes.LineHeight,
  });
}
